/** *********************************************
  Reducer is responsible for handling test data.
********************************************** */
const initialState = {
  tests: [{
    id: 1,
    customerName: 'John Doe',
    customerPhone: '123-555-1234',
    startDate: '09/21/17',
    delay: 'No-delay',
    email: 'jdoe@example.com',
    address: '25 Broadway New York NY 10004',
    city: null,
    state: null,
    zipCode: null,
    country: null,
    status: 'Complete',
    instrumentLocation: '',
    lastCalibration: '',
    gc: '',
    notes: ''
  }, {
    id: 2,
    customerName: 'Jane Doe',
    startDate: '09/21/17',
    address: 'Keas 69 Str. Chalandri Athens 15234',
    email: 'jdoe@example.com',
    status: 'Complete',
    gc: ''
  }, {
    id: 3,
    customerName: 'Jack Doe',
    startDate: '12/12/13',
    address: '25 Broadway New York NY 10004',
    email: 'jack_d@doe.com',
    status: 'Incomplete',
    gc: ''
  }, {
    id: 4,
    customerName: 'Jacob Doe',
    startDate: '08/21/16',
    address: '25 Broadway New York NY 10004',
    email: 'jackod@example.com',
    status: 'Complete',
    gc: ''
  }, {
    id: 5,
    customerName: 'Julia Doe',
    startDate: '09/21/18',
    address: '25 Broadway New York NY 10004',
    email: 'doe_julia@example2.com',
    status: 'Incomplete',
    gc: ''
  }, {
    id: 6,
    customerName: 'George Doe',
    startDate: '09/21/14',
    address: '25 Broadway New York NY 10004',
    email: 'george@example.com',
    status: 'Complete',
    gc: ''
  }]
};

export default (state=initialState, action) => {
  return state;
}


// WEBPACK FOOTER //
// src/reducers/tests.js